// app/privacy-policy/page.jsx
// Bootstrap 5 + Bootstrap Icons
import React from "react";
import { Link } from "react-router-dom";
// Import the React Bootstrap components
// import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Button from 'react-bootstrap/Button';

export default function PrivacyPolicy() {
  return (
    <div className="bg-light py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="mb-5">
              <Link to="/" className="btn btn-primary btn-lg">
                <i class="bi bi-house me-2"></i>
                back to home
              </Link>
            </div>
            <div className="card border-0 shadow rounded-4">
              <div className="card-body p-4 p-md-5">
                {/* Header */}
                <div className="text-center mb-5">
                  <i className="bi bi-shield-lock-fill text-primary display-3"></i>
                  <h1 className="fw-bold mt-3">Privacy Policy</h1>
                  <p className="text-muted mb-0">
                    <strong>Effective Date:</strong> July 21, 2026
                  </p>
                </div>

                {/* Intro */}
                <section className="mb-5">
                  <h3 className="fw-bold mb-3">
                    <i className="bi bi-whatsapp text-success me-2"></i>
                    Privacy Policy for WhatsApp Chatbot
                  </h3>

                  <p>
                    This Privacy Policy explains how
                    <strong> Tushar Suryawanshi Management Pvt Ltd </strong>
                    collects, uses, stores, and protects information when you
                    interact with our WhatsApp Chatbot.
                  </p>

                  <p>
                    By using our WhatsApp Chatbot, you agree to the collection
                    and use of information in accordance with this Privacy
                    Policy.
                  </p>
                </section>

                <hr />

                {/* Information */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-person-lines-fill text-primary me-2"></i>
                    1. Information We Collect
                  </h3>

                  <p>
                    When you communicate with our WhatsApp Chatbot, we may
                    collect the following information:
                  </p>

                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <i className="bi bi-telephone-fill text-success me-2"></i>
                      Your WhatsApp phone number
                    </li>
                    <li className="list-group-item">
                      <i className="bi bi-person-fill text-primary me-2"></i>
                      Your display name (if provided by WhatsApp)
                    </li>
                    <li className="list-group-item">
                      <i className="bi bi-chat-dots-fill text-info me-2"></i>
                      Messages you send to the chatbot
                    </li>
                    <li className="list-group-item">
                      <i className="bi bi-file-earmark-fill text-warning me-2"></i>
                      Media files (images, videos, documents, audio)
                    </li>
                    <li className="list-group-item">
                      <i className="bi bi-clock-history text-secondary me-2"></i>
                      Date and time of interactions
                    </li>
                    <li className="list-group-item">
                      <i className="bi bi-phone-fill text-dark me-2"></i>
                      Device or message metadata provided by WhatsApp
                    </li>
                  </ul>

                  <p className="mt-3">
                    We only collect information necessary to provide our
                    services.
                  </p>
                </section>

                <hr />

                {/* Use */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-gear-fill text-primary me-2"></i>
                    2. How We Use Your Information
                  </h3>

                  <ul>
                    <li>Respond to your inquiries</li>
                    <li>Provide customer support</li>
                    <li>Process your requests</li>
                    <li>Improve chatbot services</li>
                    <li>Maintain conversation history</li>
                    <li>Monitor service performance</li>
                    <li>Detect fraud and abuse</li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </section>

                <hr />

                {/* Sharing */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-share-fill text-primary me-2"></i>
                    3. Information Sharing
                  </h3>

                  <p>
                    We do <strong>not</strong> sell, rent, or trade your
                    personal information.
                  </p>

                  <p>We may share information only:</p>

                  <ul>
                    <li>With trusted service providers.</li>
                    <li>When required by law.</li>
                    <li>To protect our legal rights.</li>
                    <li>With WhatsApp (Meta) for message delivery.</li>
                  </ul>
                </section>

                <hr />

                {/* Security */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-shield-check text-primary me-2"></i>
                    4. Data Storage and Security
                  </h3>

                  <div className="alert alert-primary">
                    <i className="bi bi-lock-fill me-2"></i>
                    We implement appropriate technical and organizational
                    security measures to protect your information from
                    unauthorized access, disclosure, alteration, or destruction.
                  </div>

                  <p>
                    However, no Internet transmission method is completely
                    secure.
                  </p>
                </section>

                <hr />

                {/* Retention */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-database-fill text-primary me-2"></i>
                    5. Data Retention
                  </h3>

                  <p>
                    We retain conversation history only as long as needed to:
                  </p>

                  <ul>
                    <li>Provide customer support</li>
                    <li>Improve our services</li>
                    <li>Meet legal requirements</li>
                    <li>Resolve disputes</li>
                  </ul>

                  <p>
                    Data is securely deleted or anonymized when no longer
                    required.
                  </p>
                </section>

                <hr />

                {/* Third Party */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-cloud-fill text-primary me-2"></i>
                    6. Third-Party Services
                  </h3>

                  <ul>
                    <li>WhatsApp Business Platform</li>
                    <li>Meta Platforms</li>
                    <li>Cloud Hosting Providers</li>
                    <li>Database & Storage Services</li>
                  </ul>

                  <p>
                    These providers may process information according to their
                    own privacy policies.
                  </p>
                </section>

                <hr />

                {/* Rights */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-person-check-fill text-primary me-2"></i>
                    7. User Rights
                  </h3>

                  <ul>
                    <li>Request access to your information</li>
                    <li>Request corrections</li>
                    <li>Request deletion</li>
                    <li>Withdraw consent where applicable</li>
                    <li>Know how your information is processed</li>
                  </ul>
                </section>

                <hr />

                {/* Children */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-people-fill text-primary me-2"></i>
                    8. Children's Privacy
                  </h3>

                  <p>
                    Our WhatsApp Chatbot is not intended for children. We do not
                    knowingly collect personal information from children.
                  </p>
                </section>

                <hr />

                {/* Updates */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-arrow-repeat text-primary me-2"></i>
                    9. Changes to This Privacy Policy
                  </h3>

                  <p>
                    We may update this Privacy Policy from time to time. Any
                    changes become effective immediately after publication on
                    this page.
                  </p>
                </section>

                <hr />

                {/* Contact */}
                <section className="my-5">
                  <h3 className="fw-bold">
                    <i className="bi bi-envelope-fill text-primary me-2"></i>
                    10. Contact Us
                  </h3>

                  <div className="card bg-light border">
                    <div className="card-body">
                      <p>
                        <i className="bi bi-building me-2 text-primary"></i>
                        <strong>Company:</strong> Tushar Suryawanshi Management
                        Pvt Ltd
                      </p>

                      <p>
                        <i className="bi bi-envelope-at-fill me-2 text-danger"></i>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:tsm.info.collection@gmail.com">
                          tsm.info.collection@gmail.com
                        </a>
                      </p>

                      <p className="mb-0">
                        <i className="bi bi-geo-alt-fill me-2 text-success"></i>
                        <strong>Address 1:</strong>
                        <br />
                        B9, Raysons Prestige,
                        <br />
                        In Front Of Damini Hotel,
                        <br />
                        Tarabai Park,
                        <br />
                        Kolhapur - 416003,
                        <br />
                        Maharashtra, India
                      </p>
                      
                      <p className="mt-3">
                        <i className="bi bi-geo-alt-fill me-2 text-success"></i>
                        <strong>Address 2:</strong>
                        <br />
                        At Radewadi,
                        <br />
                        post Ankalkhop,
                        <br />
                        taluka palus,
                        <br />
                        dist sangli - 416316,
                        <br />
                         Maharastra, India
                      </p>
                    </div>
                  </div>
                </section>

                <hr />

                {/* Consent */}
                <section>
                  <h3 className="fw-bold">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Consent
                  </h3>

                  <div className="alert alert-success mb-0">
                    By communicating with our WhatsApp Chatbot, you acknowledge
                    that you have read and understood this Privacy Policy and
                    consent to the collection and use of your information as
                    described above.
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
